"use strict";
/* Generated from:
 * ap-southeast-1 (https://doigdx0kgq9el.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class ConfluenceAttachmentToIndexFieldMapping {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConfluenceAttachmentToIndexFieldMapping = ConfluenceAttachmentToIndexFieldMapping;
class SalesforceStandardObjectConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceStandardObjectConfiguration = SalesforceStandardObjectConfiguration;
class SalesforceChatterFeedConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceChatterFeedConfiguration = SalesforceChatterFeedConfiguration;
class SalesforceConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceConfiguration = SalesforceConfiguration;
class ColumnConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ColumnConfiguration = ColumnConfiguration;
class ServiceNowKnowledgeArticleConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ServiceNowKnowledgeArticleConfiguration = ServiceNowKnowledgeArticleConfiguration;
class ConfluenceSpaceConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConfluenceSpaceConfiguration = ConfluenceSpaceConfiguration;
class GoogleDriveConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.GoogleDriveConfiguration = GoogleDriveConfiguration;
class S3Path {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.S3Path = S3Path;
class ServiceNowConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ServiceNowConfiguration = ServiceNowConfiguration;
class ConfluenceConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConfluenceConfiguration = ConfluenceConfiguration;
class ConfluencePageToIndexFieldMapping {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConfluencePageToIndexFieldMapping = ConfluencePageToIndexFieldMapping;
class DatabaseConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DatabaseConfiguration = DatabaseConfiguration;
class SqlConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SqlConfiguration = SqlConfiguration;
class S3DataSourceConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.S3DataSourceConfiguration = S3DataSourceConfiguration;
class ConfluenceBlogConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConfluenceBlogConfiguration = ConfluenceBlogConfiguration;
class ConfluencePageConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConfluencePageConfiguration = ConfluencePageConfiguration;
class ConnectionConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConnectionConfiguration = ConnectionConfiguration;
class ServiceNowServiceCatalogConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ServiceNowServiceCatalogConfiguration = ServiceNowServiceCatalogConfiguration;
class SalesforceStandardObjectAttachmentConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceStandardObjectAttachmentConfiguration = SalesforceStandardObjectAttachmentConfiguration;
class SalesforceCustomKnowledgeArticleTypeConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceCustomKnowledgeArticleTypeConfiguration = SalesforceCustomKnowledgeArticleTypeConfiguration;
class ConfluenceBlogToIndexFieldMapping {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConfluenceBlogToIndexFieldMapping = ConfluenceBlogToIndexFieldMapping;
class OneDriveUsers {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OneDriveUsers = OneDriveUsers;
class AclConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AclConfiguration = AclConfiguration;
class SalesforceStandardKnowledgeArticleTypeConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceStandardKnowledgeArticleTypeConfiguration = SalesforceStandardKnowledgeArticleTypeConfiguration;
class ConfluenceAttachmentConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConfluenceAttachmentConfiguration = ConfluenceAttachmentConfiguration;
class DataSourceVpcConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DataSourceVpcConfiguration = DataSourceVpcConfiguration;
class SalesforceKnowledgeArticleConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceKnowledgeArticleConfiguration = SalesforceKnowledgeArticleConfiguration;
class AccessControlListConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AccessControlListConfiguration = AccessControlListConfiguration;
class DataSourceToIndexFieldMapping {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DataSourceToIndexFieldMapping = DataSourceToIndexFieldMapping;
class ConfluenceSpaceToIndexFieldMapping {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConfluenceSpaceToIndexFieldMapping = ConfluenceSpaceToIndexFieldMapping;
class OneDriveConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OneDriveConfiguration = OneDriveConfiguration;
class DataSourceConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DataSourceConfiguration = DataSourceConfiguration;
class SharePointConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SharePointConfiguration = SharePointConfiguration;
class DocumentsMetadataConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DocumentsMetadataConfiguration = DocumentsMetadataConfiguration;
class DataSource extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::Kendra::DataSource', properties);
    }
}
exports.default = DataSource;
DataSource.ConfluenceAttachmentToIndexFieldMapping = ConfluenceAttachmentToIndexFieldMapping;
DataSource.SalesforceStandardObjectConfiguration = SalesforceStandardObjectConfiguration;
DataSource.SalesforceChatterFeedConfiguration = SalesforceChatterFeedConfiguration;
DataSource.SalesforceConfiguration = SalesforceConfiguration;
DataSource.ColumnConfiguration = ColumnConfiguration;
DataSource.ServiceNowKnowledgeArticleConfiguration = ServiceNowKnowledgeArticleConfiguration;
DataSource.ConfluenceSpaceConfiguration = ConfluenceSpaceConfiguration;
DataSource.GoogleDriveConfiguration = GoogleDriveConfiguration;
DataSource.S3Path = S3Path;
DataSource.ServiceNowConfiguration = ServiceNowConfiguration;
DataSource.ConfluenceConfiguration = ConfluenceConfiguration;
DataSource.ConfluencePageToIndexFieldMapping = ConfluencePageToIndexFieldMapping;
DataSource.DatabaseConfiguration = DatabaseConfiguration;
DataSource.SqlConfiguration = SqlConfiguration;
DataSource.S3DataSourceConfiguration = S3DataSourceConfiguration;
DataSource.ConfluenceBlogConfiguration = ConfluenceBlogConfiguration;
DataSource.ConfluencePageConfiguration = ConfluencePageConfiguration;
DataSource.ConnectionConfiguration = ConnectionConfiguration;
DataSource.ServiceNowServiceCatalogConfiguration = ServiceNowServiceCatalogConfiguration;
DataSource.SalesforceStandardObjectAttachmentConfiguration = SalesforceStandardObjectAttachmentConfiguration;
DataSource.SalesforceCustomKnowledgeArticleTypeConfiguration = SalesforceCustomKnowledgeArticleTypeConfiguration;
DataSource.ConfluenceBlogToIndexFieldMapping = ConfluenceBlogToIndexFieldMapping;
DataSource.OneDriveUsers = OneDriveUsers;
DataSource.AclConfiguration = AclConfiguration;
DataSource.SalesforceStandardKnowledgeArticleTypeConfiguration = SalesforceStandardKnowledgeArticleTypeConfiguration;
DataSource.ConfluenceAttachmentConfiguration = ConfluenceAttachmentConfiguration;
DataSource.DataSourceVpcConfiguration = DataSourceVpcConfiguration;
DataSource.SalesforceKnowledgeArticleConfiguration = SalesforceKnowledgeArticleConfiguration;
DataSource.AccessControlListConfiguration = AccessControlListConfiguration;
DataSource.DataSourceToIndexFieldMapping = DataSourceToIndexFieldMapping;
DataSource.ConfluenceSpaceToIndexFieldMapping = ConfluenceSpaceToIndexFieldMapping;
DataSource.OneDriveConfiguration = OneDriveConfiguration;
DataSource.DataSourceConfiguration = DataSourceConfiguration;
DataSource.SharePointConfiguration = SharePointConfiguration;
DataSource.DocumentsMetadataConfiguration = DocumentsMetadataConfiguration;
